import { stores } from '@stores/index';
import isFeatureEnabled, { Feature } from '@utils/enableFeature';

const initFeatureBasedStores = async () => {
  const { modelListStore, trackingPlanListStore } = stores;
  const isEnabled = isFeatureEnabled();
  const isModelEnabled = isEnabled(Feature.models);
  const isTrackingPlanEnabled = isEnabled(Feature.trackingPlans);
  const apiCalls = [];

  if (isModelEnabled) {
    apiCalls.push(modelListStore.getModels(false));
  }

  if (isTrackingPlanEnabled) {
    apiCalls.push(trackingPlanListStore.getPlans());
  }

  if (apiCalls.length > 0) {
    await Promise.all(apiCalls);
  }
};

export const getPermissions = (
  resources: { id: string; permissions?: { id: string; isLocked: boolean } }[],
) =>
  resources.map((x) => ({
    id: x.id,
    permissionId: x.permissions?.id,
    locked: x.permissions?.isLocked,
  }));

const loadStores = async () => {
  const { workspaceStore, sourcesListStore, destinationsListStore, transformationsListStore } =
    stores;

  const apiCalls = [
    workspaceStore.getWorkspace(),
    sourcesListStore.getSources(),
    destinationsListStore.getDestinations(),
    transformationsListStore.getTransformations(),
  ];
  await Promise.all(apiCalls);
  await initFeatureBasedStores();
};

const isStoresLoaded = () => {
  const {
    workspaceStore,
    sourcesListStore,
    destinationsListStore,
    sourceDefinitionsListStore,
    destinationDefsListStore,
    transformationsListStore,
  } = stores;
  return (
    sourceDefinitionsListStore.sourceDefinitions.length > 0 &&
    destinationDefsListStore.destinationDefs.length > 0 &&
    sourcesListStore.firstLoad &&
    destinationsListStore.firstLoad &&
    transformationsListStore.firstLoad &&
    workspaceStore.firstLoad
  );
};

export { loadStores, isStoresLoaded };
